import { BaseButton } from 'iebt-zing-storybook'
import React from 'react'
import { useSmartNavigateLegacy as useNavigate } from 'components/SmartLink'
import { DeleteFormat, deleteProvider } from 'sharedKernel/api'
import { showDoubleActionPopUp } from 'components/popup/doubleAction'
import { showToast } from 'components/toast'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { hasAccess } from 'sharedKernel/auth/behavior'
import { getHubRoute } from 'sharedKernel/handlers'
import { ROUTES } from 'sharedKernel/constants'
import { trans } from 'sharedKernel/i18n'
import { EventButtonsProps } from '../contract'

export const RemoveEventButton = ({ eventId, isOwner }: EventButtonsProps): JSX.Element => {
  const labels = {
    toolTipContent: trans('Remover')
  }
  const navigate = useNavigate()
  const haveAccess = hasAccess('challenge', 'delete')
  if (!haveAccess) {
    return <></>
  }
  if (!isOwner) {
    return <></>
  }
  const onSuccessDeletion = async (): Promise<void> => {
    showToast('success', 'Evento removido')
    navigate(getHubRoute(ROUTES.HUB.COMPANY.EVENTS_LIST))
  }

  const { mutate: deleteEvent } = deleteProvider(onSuccessDeletion)
  const request: DeleteFormat = {
    url: `/v1/hub/company/event/${eventId}`
  }
  const handleRemoveEvent = (): void => {
    showDoubleActionPopUp({
      title: 'Excluir evento',
      message: 'Deseja realmente excluir esse evento?',
      buttons: [{ text: 'Sim' }, { text: 'Não' }],
      action: () => deleteEvent(request)
    })
  }

  const icon = <FontAwesomeIcon icon={['fas', 'trash']} size="xl" />

  return (
    <BaseButton
      btnContent={icon}
      variant="primary-invert"
      size="icon"
      tippyContent={labels.toolTipContent}
      onClick={() => {
        handleRemoveEvent()
      }}
    />
  )
}
